
import { useGLTF } from "@react-three/drei";

// Paths to 3D models
export const MODEL_PATHS = {
  field: "/models/football_field_for_gtec.glb",
  player: "/models/goem_football_playerred.glb",
  ball: "/models/soccer_ball.glb"
};

// Function to preload models correctly
export function preloadModels() {
  console.log("Preloading models...");
  try {
    Object.values(MODEL_PATHS).forEach(path => {
      console.log(`Preloading model: ${path}`);
      useGLTF.preload(path);
    });
  } catch (error) {
    console.error("Failed to preload models:", error);
  }
}
